import React from 'react'
import { Alert } from 'antd'
import { LinkOutlined } from '@ant-design/icons'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../../services'

/**
 * Shown when the domain has no targetable delivery channel. Not closable: it reports domain
 * configuration that stays true until a channel is activated, not a one-time notice.
 *
 * The link opens in a new tab so the draft in progress is kept. A new tab carries no history state,
 * so it lands at the top of the settings page rather than scrolled to Send Integrations.
 */
export const NoActiveChannelsBanner = () => {
    const appSvc = useService(AppService)
    const settingsHref = appSvc.routeWithinDomain('#settings', true)

    return (
        <Alert
            className="no-active-channels-banner"
            type="warning"
            showIcon={true}
            message="No active delivery channels available to target"
            description={
                <p style={{ margin: 0 }}>
                    Notifications from this domain can't reach subscribers until a delivery channel is active. To get
                    started, set up your Send Integrations in{' '}
                    <a href={settingsHref} target="_blank" rel="noopener noreferrer">
                        Domain Settings
                        <LinkOutlined style={{ marginLeft: 4 }} />
                    </a>
                    .
                </p>
            }
            style={{ boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.15)' }}
        />
    )
}
